import { AfterViewInit, Directive, ElementRef, Inject, Input } from '@angular/core'

@Directive({
    selector: '[autofocus]',
    standalone: false
})
export class AutofocusDirective implements AfterViewInit {

    private _autofocus

    constructor(@Inject(ElementRef) private el: ElementRef,
    ) {}

    @Input() set autofocus(condition: boolean) {
        this._autofocus = condition != false
    }

    ngAfterViewInit(): void {
        const touchDevice = window.matchMedia('(pointer: coarse)')
        if (touchDevice === undefined || touchDevice.matches === false) {
            if (this._autofocus || typeof this._autofocus === 'undefined') {
                this.el.nativeElement.focus()
            }
        }
    }


}